import Swal from 'sweetalert2'
import { quickReplyHtml } from './quickReplyHtml'
import { sweetAlertCommonParams } from '../../functions/utils'
import { lang } from '../../assets/lang'

export const quickReplyModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.quick_reply_modal_title,
    html: quickReplyHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })
      
      const replyType = $('#quick-reply-type')
      const buttonTextGroup = $('#quick-reply-button-text-group')
      const postbackGroup = $('#quick-reply-postback-group')
      
      const replyTypeValue = oldData.replyType || ''
      const buttonTextValue = oldData.buttonText || ''
      const postbackIdValue = oldData.postbackId || ''

      replyType.val(replyTypeValue).trigger('change')

      var page_table_id = window.xitFlowBuilderData.page_table_id
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
      var base_url = window.xitFlowBuilderData.base_url
      
      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_dropdown_postback',
        dataType: 'JSON',
        data: { page_table_id, instagram_bot_addon },
        success:function(response){
          $("#quick-reply-postback").html(response.dropdown_str);
          if ('postback' === replyTypeValue) {
            $('#quick-reply-postback').val(postbackIdValue).trigger('change')
          }
        }
      })

      if ('postback' === replyTypeValue) {
        $('#quick-reply-button-text').val(buttonTextValue)
        $('#quick-reply-postback').val(postbackIdValue).trigger('change')

        buttonTextGroup.removeClass('d-none')
        postbackGroup.removeClass('d-none')
      } else if ('newPostback' === replyTypeValue) {
        $('#quick-reply-button-text').val(buttonTextValue)
        buttonTextGroup.removeClass('d-none')
      }

      replyType.on('change', function(e) {
        const selectedType = e.target.value

        if ('newPostback' === selectedType) {
          postbackGroup.addClass('d-none')
          buttonTextGroup.removeClass('d-none')
        } else if ('postback' === selectedType) {
          // Display spinner before loading postback list
          Swal.showLoading()
          
          // Hides spinner after loading postback list
          Swal.hideLoading()

          buttonTextGroup.removeClass('d-none')
          postbackGroup.removeClass('d-none')

          // TODO
          // Load post back IDs and fill in select options
        } else {
          buttonTextGroup.addClass('d-none')
          postbackGroup.addClass('d-none')
        }
      })
    },

    preConfirm: () => {
      const replyType = $('#quick-reply-type')
      const buttonText = $('#quick-reply-button-text')
      const postback = $('#quick-reply-postback')

      const replyTypeValue = replyType.val()
      
      if (! replyTypeValue) {
        Swal.showValidationMessage(lang.quick_reply_modal_msg_reply_type)
      }

      const data = {
        replyType: replyTypeValue,
        replyTypeText: $('#quick-reply-type option:selected').text(),
      }
      
      const buttonTextValue = buttonText.val()
      const postbackIdValue = postback.val()

      if ('postback' === replyTypeValue) {
        if (! buttonTextValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_button_text)
        } else if (! postbackIdValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_postback_id)
        }

        data['buttonText'] = buttonTextValue
        data['postbackId'] = postbackIdValue
        data['postbackIdText'] = $('#quick-reply-postback option:selected').text()
      } else if ('newPostback' === replyTypeValue) {
        if (! buttonTextValue) {
          Swal.showValidationMessage(lang.quick_reply_modal_msg_button_text)
        }

        data['buttonText'] = buttonTextValue
      }

      return data
    },    
  })
}